<template>
	<div>
		<hr/>
		
		<h2>Contratos</h2>
		<br>
    <a @click="$router.go(-1)">regresar</a>
    <br><br>
		<input type="text" id='busca' align="center" v-model='abuscar'  size="20" placeholder="Buscar"autofocus > 
		<br>
		<br>
    <br>

		<ul id='contratos-lista' v-if="contratosTodos !=null" align="left">
			<li v-for="contra in buscando" >	

				<div v-on:click="lanza(contra.id, contra.inquilinoId, contra.propiedadId, contra.inquilino, contra.propiedad, contra.giro, contra.familia, contra.subfamilia, contra.dueno, contra.emailInquilino, contra.importeMes)" v-if="esRentado(contra.status)">
					<strong>
						
					    Contrato #  {{contra.id}} <br>
						  {{contra.inquilino}} <br><br>
						  {{contra.propiedad}}<br><br>
						  <font color="blue">{{contra.giro}}<br>
					    {{contra.nombreComercial}} </font><br><br>
					    {{contra.familia}} <br>
					    {{contra.subfamilia}} <br><br>
                        {{contra.status}} <br>

					</strong>
				<br>
				<button type='button' v-on:click="lanza(contra.id, contra.inquilinoId, contra.propiedadId, contra.inquilino, contra.propiedad, contra.giro, contra.familia, contra.subfamilia, contra.dueno, contra.emailInquilino, contra.importeMes)" class="button is-primary is-rounded"> Seleccionar
				</button>
        </div>

  		</li>
		</ul>
		<span v-else>Cargando contratos ...</span>
	</div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'Contratos-buscar',
  mounted(){
  	this.getContratos();
  },
  data () {
    return {
      contratosTodos: null,
      abuscar:''
    }
  },
  methods:{	
    	lanza: function(idCon, inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta){
  	    	  this.$emit('eventoC',idCon, inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta );
    	},
    	getContratos(){
    		axios.get('https://www.directodo.com/Rentus/accesosdb/leeContratos.php')
    		     .then((respuesta) => {
    		     	this.contratosTodos = respuesta.data;
    			 });
    	},
      esRentado(status){
        if (status == 'RENTADO') {
          return true;
        }
        else return false;
      }

  },
  computed:{
  	buscando: function () {
  		return this.contratosTodos.filter((item) => 
  				   item.giro.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.inquilino.toUpperCase().includes(this.abuscar.toUpperCase()) 
          || item.id.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.propiedad.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.familia.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.subfamilia.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.nombreComercial.toUpperCase().includes(this.abuscar.toUpperCase()) );

  	}
  }
}

</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/Contratos-buscar.vue